/**
 * Controller for the vd-tooltip component.
 *
 * @class TooltipController
 */
export default class TooltipController {
  constructor($attrs) {
    'ngInject'
    this._$attrs = $attrs
  }

  $postLink() {
    this._$attrs.$addClass('vd-popover-container')
    this._$attrs.$addClass('vd-popover-container--tooltip')
  }
}
